import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { company, serviceAreas } from '../data/company';
export function Coverage() {
  return <section id="areas" className="border-t border-neutral-200 bg-white" data-id="element-12" data-mp="4p8k0cedomvw">
      <div className="mx-auto max-w-6xl px-6 py-20 lg:py-28" data-id="element-13" data-mp="ifkg0me335sb">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:items-start" data-id="element-14" data-mp="doc3vildd6bg">
          <div data-id="element-15" data-mp="scyljqygya5u">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-500" data-id="element-16" data-mp="scgs1236ya1m">
              Coverage
            </p>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-17" data-mp="nd3v1oilvmlb">
              Based in Salem, working the whole valley.
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-neutral-600" data-id="element-18" data-mp="we21sekfi87l">
              Not on the list? Call us — we travel for larger jobs.
            </p>

            <ul className="mt-8 grid grid-cols-2 gap-x-8" data-id="element-19" data-mp="336uo8lpd84ha">
              {serviceAreas.map(area => <li key={area} className="flex items-center gap-2 border-b border-neutral-200 py-3 text-sm text-neutral-700" data-id="element-20" data-mp="3i59rmerip76j">
                  <MapPin className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-21" data-mp="3n28kktzg3835" />
                  {area}
                </li>)}
            </ul>

            <a href={company.google} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-ink underline decoration-gold decoration-2 underline-offset-[6px] hover:text-neutral-600" data-id="element-22" data-mp="pjt2h5axv3e">
              View us on Google Maps
              <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="emovm75t4btw" />
            </a>
          </div>

          <div className="border border-neutral-200 p-2" data-id="element-24" data-mp="jl9v24d8irha">
            <iframe src={company.mapEmbed} title="Map of North Star Exterior Cleaning's service area around Salem, Oregon" loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-[22rem] w-full border-0 bg-neutral-100 lg:h-[32rem]" data-id="element-25" data-mp="2gh7lbz9dezfv" />
          </div>
        </div>
      </div>
    </section>;
}